import { LinearGradient } from 'expo-linear-gradient'
import { NativeBaseProvider } from 'native-base'
import React from 'react'

import theme from '../theme'

interface DesignSystemProviderProps {
  children: React.ReactNode
}

const nativeBaseConfig = {
  dependencies: {
    'linear-gradient': LinearGradient,
  },
}

const DesignSystemProvider: React.FC<DesignSystemProviderProps> = ({ children }) => {
  return (
    <NativeBaseProvider theme={theme} config={nativeBaseConfig}>
      {children}
    </NativeBaseProvider>
  )
}

export default DesignSystemProvider
